/**
 * @voltxampere/ui — 20x4 character LCD variant (Sprint 43-7, placeholder)
 *
 * PLACEHOLDER. Larger sibling of the 16x2 — same HD44780-class
 * controller, 20 columns × 4 rows. Same parallel bus, same Sprint
 * 47+ deferral for full simulation.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const displayLcd20x4 = {
    id: "lcd-20x4",
    nameTr: "20x4 Karakter LCD (HD44780, placeholder)",
    nameEn: "20x4 Character LCD (HD44780, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "LCD",
    defaultValue: "LCD-20x4",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=display-lcd-20x4.js.map